import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts'
import { formatCurrency } from '@utils/format.js'
import type { LancamentoItem } from './financeiroTypes.js'

type Props = { lancamentos: LancamentoItem[] }

export function CurvaDesembolso({ lancamentos }: Props) {
  const pagos = lancamentos
    .filter((l) => l.status === 'pago')
    .sort((a, b) => a.data.localeCompare(b.data))
  if (pagos.length < 2) return null

  const byMonth: Record<string, number> = {}
  for (const l of pagos) {
    const m = l.data.slice(0, 7)
    byMonth[m] = (byMonth[m] ?? 0) + l.valor
  }

  let acc = 0
  const curvaData = Object.entries(byMonth)
    .sort()
    .map(([m, v]) => {
      acc += v
      const [y, mo] = m.split('-')
      const label = new Date(Number(y), Number(mo) - 1, 1).toLocaleDateString('pt-BR', {
        month: 'short',
        year: '2-digit',
      })
      return { mes: label, acumulado: acc, mensal: v }
    })

  return (
    <section className='cf3-block' aria-labelledby='curva-title'>
      <h3 id='curva-title' className='cf3-subsection-title'>
        Curva de Desembolso
      </h3>
      <div className='cf3-fin-dash__chart-card'>
        <ResponsiveContainer width='99%' height={220}>
          <LineChart data={curvaData} margin={{ top: 8, right: 16, left: 4, bottom: 4 }}>
            <CartesianGrid strokeDasharray='3 3' stroke='#DEDAD0' />
            <XAxis dataKey='mes' tick={{ fontSize: 10, fill: '#6E6859' }} />
            <YAxis
              tick={{ fontSize: 10, fill: '#6E6859' }}
              tickFormatter={(v) => (v >= 1000 ? `R$${(v / 1000).toFixed(0)}k` : `R$${v}`)}
            />
            <Tooltip
              formatter={(v, name) => [
                formatCurrency(Number(v)),
                name === 'acumulado' ? 'Acumulado' : 'No mês',
              ]}
              contentStyle={{
                background: '#fff',
                border: '1px solid #DEDAD0',
                borderRadius: 8,
                fontSize: 12,
              }}
              labelStyle={{ color: '#1A1814' }}
            />
            <Line
              type='monotone'
              dataKey='acumulado'
              name='acumulado'
              stroke='#E8A830'
              strokeWidth={2}
              dot={{ r: 3 }}
            />
            <Line
              type='monotone'
              dataKey='mensal'
              name='mensal'
              stroke='#1B3A6B'
              strokeWidth={1.5}
              dot={false}
              strokeDasharray='4 2'
            />
          </LineChart>
        </ResponsiveContainer>
        <p className='cf3-fin-dash__chart-note'>
          Acumulado (linha sólida) · Mensal (tracejado, gastos pagos)
        </p>
      </div>
    </section>
  )
}
